import { Box } from '@mui/material';

import Accordion from '../../accordion/accordion';
import Typography from '../../typography/typography';

export interface IDiscountSummary {
	itemDiscount: number | string;
	additionalDiscount?: number | string;
	totalDiscount?: number | string;
	promotionAmount?: number | string;
	currencySymbol: string;
}
interface IDiscountSummaryProps {
	data: IDiscountSummary;
	enablePromotions?: boolean;
}

const DiscountSummary: React.FC<IDiscountSummaryProps> = ({
	data,
	enablePromotions
}) => {
	return (
		<Accordion
			title={
				<Typography type='s3' weight='medium' color='theme.secondary.1000'>
					Discounts
				</Typography>
			}
			accordionProps={{
				defaultExpanded: true,
				sx: {
					borderBottomWidth: 1,
					'& .MuiAccordionSummary-root': { borderBottomWidth: 1 }
				}
			}}>
			<Box className='calculationSummary--SummaryContainer'>
				<Box className='calculationSummary--SummaryItem'>
					<Typography type='s5' weight='medium' color='theme.secondary.800'>
						Item Discount
					</Typography>
					<Typography type='s3' weight='medium' color='theme.secondary.1000'>
						{data.currencySymbol} {data.itemDiscount}
					</Typography>
				</Box>
				{Number(data.additionalDiscount) > 0 &&
					<Box className='calculationSummary--SummaryItem'>
						<Typography type='s5' weight='medium' color='theme.secondary.800'>
							Additional Discount
						</Typography>
						<Typography type='s3' weight='medium' color='theme.secondary.1000'>
							{data.currencySymbol} {data.additionalDiscount}
						</Typography>
					</Box>
				}
				{Boolean(enablePromotions) && (
					<Box className='calculationSummary--SummaryItem'>
						<Typography type='s5' weight='medium' color='theme.secondary.800'>
							Promotion Amount
						</Typography>
						<Typography type='s3' weight='medium' color='theme.secondary.1000'>
							{data.currencySymbol} {data.promotionAmount}
						</Typography>
					</Box>
				)}
				<Box className='calculationSummary--SummaryItem'>
					<Typography type='s5' weight='medium' color='theme.secondary.800'>
						Total Discount
					</Typography>
					<Typography type='s3' weight='medium' color='theme.secondary.1000'>
						{data.currencySymbol} {data.totalDiscount}
					</Typography>
				</Box>
			</Box>
		</Accordion>
	);
};

export default DiscountSummary;
